import Reports from "../app/reports/reports/reports.jsx";
import ActivitiesJournal from "../app/reports/activities-journal/activities-journal.jsx";
import AssetActive from "../app/reports/asset-active/asset-active.jsx";
import OccurrenceDashboard from "../app/reports/occurrence-dashboard/occurrence-dashboard.jsx";
import CloneInfo from "../app/reports/clone-info/clone-info.jsx";
import JanitorialPrint from "../app/reports/janitorial/print/janitorial-print.jsx";
import AttendanceXray from "../app/reports/attendance-xray/attendance-xray.jsx";
import BoXray from "../app/reports/bo-xray/bo-xray.jsx";
import DispatchImageReservation from "../app/reports/dispatch-image-reservation/dispatch-image-reservation.jsx";
import AlarmList from "../app/reports/alarm-list/alarm-list.jsx";
import EventList from "../app/reports/event-list/event-list.jsx";
import EncounterList from "../app/reports/encounter-list/encounter-list.jsx";
import ListBos from "../app/reports/list_bos/list-bos.jsx";
import ScheduleGarrisonList from "../app/reports/schedule-garrison-list/schedule-garrison-list.jsx";
import SosRecords from "../app/reports/sos-records/sos-records.jsx";
import AttendanceAuditorship from "../app/reports/attendance-auditorship/attendance-auditorship.jsx";
import SentryCloudSearchInfo from "../app/reports/sentry-cloud-search/sentry-cloud-search-info.jsx";
import SchedulegarrisonAuditorship from "../app/reports/schedule-garrison-auditorship/schedulegarrison-auditorship.jsx";
import ScheduleattendanceAuditorship from "../app/reports/scheduleattendance-auditorship/scheduleattendance-auditorship.jsx";
import DispatchAuditorship from "../app/reports/dispatch-auditorship/dispatch-auditorship.jsx";
import GarrisonAuditorship from "../app/reports/garrison-auditorship/garrison-auditorship.jsx";
import GarrisonDamage from "../app/reports/garrison-damage/garrison-damage.jsx";
import FixedPlates from "../app/reports/fixed-plates/fixed-plates.jsx";
import ImageExport from "../app/reports/image-export/image-export.jsx";
import InterconnectedSearchAudit from "../app/reports/interconnected-search-audit/interconnected-search-audit.jsx";
import UserSessions from "../app/reports/user-sessions/user-sessions.jsx";
import VehiclePassagesSearch from "../app/reports/vehicle-passages-search/vehicle-passages-search.jsx";
import SystemUsage from "../app/reports/system-usage/system-usage.jsx";
import DispatchArrival from "../app/reports/dispatch-arrival/dispatch-arrival.jsx";
import AttendanceSequence from "../app/reports/attendance-sequence/attendance-sequence.jsx";
import GarrisonActions from "../app/reports/garrison_actions/garrison-actions.jsx";
import OcrIndicator from "../app/reports/ocr-indicator/ocr-indicator.jsx";
import SlaCameras from "../app/reports/sla-cameras/sla-cameras.jsx";
import SlaServer from "../app/reports/sla-server/sla-server.jsx";
import ApprovalActions from "../app/reports/approval-actions/approval-actions.jsx";
import CortexOccurrenceActions from "../app/reports/cortex-occurrence-actions/cortex-occurrence-actions.jsx";
import CollectionPointPriority from "../app/reports/collection-point-priority/collection-point-priority.jsx";
import SlaCollectionPoint from "../app/reports/sla-collection-point/sla-collection-point.jsx";
import AttendanceQuality from "../app/reports/attendance-quality/attendance-quality.jsx";
import InformationQuality from "../app/reports/information-quality/information-quality.jsx";
import DispatchQuality from "../app/reports/dispatch-quality/dispatch-quality.jsx";
import Audit from "../app/reports/audit/audit.jsx";
import IntegrationEvents from "../app/reports/integration-events/integration-events.jsx";
import NatureActions from "../app/reports/nature-actions/nature-actions.jsx";
import NatureDeviation from "../app/reports/nature-deviation/nature-deviation.jsx";
import KmCheck from "../app/reports/km-check/km-check.jsx";
import VehicleControlMileage from "../app/reports/vehicle-control-mileage/vehicle-control-mileage.jsx";
import VehicleTraffic from "../app/reports/vehicle-traffic/vehicle-traffic.jsx";
import RegisteredOccurrenceVehicles from "../app/reports/registered-occurrence-vehicles/registered-occurrence-vehicles.jsx";
import EquipmentsInUse from "../app/reports/equipments_in_use/equipments-in-use.jsx";
import FixedPostInspection from "../app/reports/fixed-post-inspection/fixed-post-inspection.jsx";
import NotificationInfo from "../app/reports/notification-info/notification-info.jsx";
import DispatchSequence from "../app/reports/dispatch-sequence/dispatch-sequence.jsx";
import DisplacementList from "../app/reports/displacement-sequence/displacement-list.jsx";
import GarrisonInspection from "../app/reports/garrison-inspection/garrison-inspection.jsx";
import DispatchByPlace from "../app/reports/dispatch-by-place/dispatch-by-place.jsx";
import FleetMaintenances from "../app/reports/fleet-maintenances/fleet-maintenances.jsx";
import FleetSupplies from "../app/reports/fleet-supplies/fleet-supplies.jsx";
import TrafficFlowRoute from "../app/reports/traffic-flow-route/traffic-flow-route.jsx";
import GarrisonList from "../app/reports/garrison-list/garrison-list.jsx";
import GarrisonLocationMap from "../app/reports/garrison-location-map/garrison-location-map.jsx";
import GarrisonMap from "../app/reports/garrison-map/garrison-map.jsx";
import TrafficFlowPoint from "../app/reports/traffic-flow-point/traffic-flow-point.jsx";
import MaterialMovements from "../app/reports/./material-movements-info/material-movements.jsx";
import MaterialMovementsInfo from "../app/reports/./material-movements-print/material-movements-info.jsx";
import MaterialXStorageInfo from "../app/reports/material-x-storage/material-x-storage-info.jsx";
import OccurrenceAssociatedVehicles from "../app/reports/occurrence-associated-vehicles/occurrence-associated-vehicles.jsx";
import EffectiveTraining from "../app/reports/effective-training/effective-training.jsx";
import OccurrenceReasons from "../app/reports/occurrence-reasons/occurrence-reasons.jsx";
import ResponsibleBo from "../app/reports/responsible-bo/responsible-bo.jsx";
import EncounterXray from "../app/reports/encounter-xray/encounter-xray.jsx";
import EncounterHeatMap from "../app/reports/encounter-heat-map/encounter-heat-map.jsx";
import AgentProductivity from "../app/reports/agent-productivity/agent-productivity.jsx";
import DispatchXray from "../app/reports/dispatch-xray/dispatch-xray.jsx";
import EventXRay from "../app/reports/event-x-ray/event-x-ray.jsx";
import CloneXray from "../app/reports/clone-xray/clone-xray.jsx";
import PassageLabelsXray from "../app/reports/passage-labels-xray/passage-labels-xray.jsx";
import OccurrenceMapping from "../app/reports/occurrence-mapping/occurrence-mapping.jsx";
import MaterialCautions from "../app/reports/material-cautions/material-cautions.jsx";
import AgentInfo from "../app/reports/agent-info/agent-info.jsx";
import OccurrencesDetails from "../app/reports/occurrences-details/occurrences-details.jsx";
import AlarmTimeline from "../app/reports/alarm-timeline/alarm-timeline.jsx";
import OccurrenceHistory from "../app/reports/occurrence-history/occurrence-history.jsx";
import OccurrencePrint from "../app/reports/occurrence-print/occurrence-print.jsx";
import ZoomedPassage from "../app/reports/zoomed-passage/zoomed-passage.jsx";
import SosXray from "../app/reports/sos-xray/sos-xray.jsx";
import SolicitationXray from "../app/reports/solicitation-xray/solicitation-xray.jsx";
import GeoComparison from "../app/reports/geo-comparison/geo-comparison.jsx";
import DispatchInfo from "../app/reports/dispatch-info/dispatch-info.jsx";
import GarrisonInfo from "../app/reports/garrison-info/garrison-info.jsx";
import CitizenHistoryInfo from "../app/reports/citizen-history-info/citizen-history-info.jsx";
import AttendanceInfo from "../app/reports/attendance-info/attendance-info.jsx";
import ScheduleAttendanceInfo from "../app/reports/schedule-attendance-info/schedule-attendance-info.jsx";
import ContactId from "../app/reports/contact-id/contact-id.jsx";
import AlarmActions from "../app/reports/alarm-actions/alarm-actions.jsx";
import AlarmStatistics from "../app/reports/alarm-statistics/alarm-statistics.jsx";
import BoApprehensions from "../app/reports/bo-apprehensions/bo-apprehensions.jsx";
import BoAuditorship from "../app/reports/bo-auditorship/bo-auditorship.jsx";
import BoTimeline from "../app/reports/bo-timeline-auditorship/bo-timeline.jsx";
import SolicitationInfo from "../app/reports/solicitation-info/solicitation-info.jsx";
import CorporationActions from "../app/reports/corporation-actions/corporation-actions.jsx";
import TrafficVehicleStay from "../app/reports/traffic-vehicle-stay/traffic-vehicle-stay.jsx";
import {requirePermission} from "./middleware.js";
import {PermissionEnum} from "../utils/enums/permission-enum.js";
import SosManagement from "../app/reports/sos-management/sos-management.jsx";
import GenericFormAnalyse from "../app/reports/generic-form-analyse/generic-form-analyse.jsx";
import AgentAbsences from "../app/reports/agent-absences/agent-absences.jsx";
import BoStolenItems from "../app/reports/bo-stolen-item/bo-stolen-items.jsx";
import DocumentExpiration from "../app/reports/document-expiration/document-expiration.jsx";
import SentryCloudSearchMap from "../app/reports/sentry-cloud-search-map/sentry-cloud-search-map.jsx";
import SosHistory from "../app/reports/sos-history/sos-history.jsx";

const RouterReports = () => [
    {
        id: "reports",
        path: "",
        Component: Reports,
        loader: requirePermission([PermissionEnum.REPORT_ALL, PermissionEnum.REPORTS_ALL])
    },
    {
        id: "activities-journal",
        path: "activities_journal",
        Component: ActivitiesJournal,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_ACTIVITY_LOG)
    },
    {
        id: "asset-active",
        path: "asset-actives",
        Component: AssetActive,
        loader: requirePermission(PermissionEnum.ERP_ASSET)
    },
    {
        id: "occurrence-dashboard",
        path: "occurrence_dashboard",
        Component: OccurrenceDashboard,
        loader: requirePermission(PermissionEnum.REPORT_OCCURRENCE_DASHBOARD)
    },
    {
        id: "clone-info",
        path: "cloneInfo",
        Component: CloneInfo,
        loader: requirePermission(PermissionEnum.SENTRY_CLONE)
    },
    {
        id: "janitorial-print",
        path: "janitorial_print/:id",
        Component: JanitorialPrint,
        loader: requirePermission(PermissionEnum.ERP_JANITORIAL)
    },
    {
        id: "attendance-xray",
        path: "attendance_x_ray",
        Component: AttendanceXray,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_ATTENDANCE_XRAY)
    },
    {
        id: "bo-xray",
        path: "bo_x_ray",
        Component: BoXray,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_BO_XRAY)
    },
    {
        id: "dispatch-image-reservation",
        path: "dispatch_image_reservation",
        Component: DispatchImageReservation,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_IMAGE_RESERVATION)
    },
    {
        id: "alarm-list",
        path: "alarm_list",
        Component: AlarmList,
        loader: requirePermission(PermissionEnum.REPORT_ALARM_LIST)
    },
    {
        id: "event-list",
        path: "event_list",
        Component: EventList,
        loader: requirePermission(PermissionEnum.REPORT_EVENT_LIST)
    },
    {
        id: "encounter-list",
        path: "encounter_list",
        Component: EncounterList,
        loader: requirePermission(PermissionEnum.REPORT_ENCOUNTER_LIST)
    },
    {
        id: "list-bos",
        path: "list_bos",
        Component: ListBos,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_BO_LIST)
    },
    {
        id: "schedule-garrison-list",
        path: "schedule_garrison_list",
        Component: ScheduleGarrisonList,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_SCHEDULE_GARRISON_LIST)
    },
    {
        id: "sos-records",
        path: "sos_records",
        Component: SosRecords,
        loader: requirePermission(PermissionEnum.REPORT_SOS_RECORDS)
    },
    {
        id: "attendance-auditorship",
        path: "attendance_auditorship",
        Component: AttendanceAuditorship,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_ATTENDANCE_AUDIT)
    },
    {
        id: "sentry-cloud-search-info-report",
        path: "sentry-cloud-search-info-report",
        Component: SentryCloudSearchInfo,
        loader: requirePermission(PermissionEnum.PASSAGE_SEARCH_SENTRYCLOUD)
    },
    {
        id: "schedulegarrison-auditorship",
        path: "schedulegarrison_auditorship",
        Component: SchedulegarrisonAuditorship,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_SCHEDULE_GARRISON_AUDIT)
    },
    {
        id: "scheduleattendance-auditorship",
        path: "scheduleattendance_auditorship",
        Component: ScheduleattendanceAuditorship,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_SCHEDULE_ATTENDANCE_AUDIT)
    },
    {
        id: "dispatch-auditorship",
        path: "dispatch_auditorship",
        Component: DispatchAuditorship,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_DISPATCH_AUDIT)
    },
    {
        id: "garrison-auditorship",
        path: "garrison_audit",
        Component: GarrisonAuditorship,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_GARRISON_AUDIT)
    },
    {
        id: "garrison-damage",
        path: "garrison_damage/:id?",
        Component: GarrisonDamage,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_VEHICLE_DAMAGE)
    },
    {
        id: "fixed-plates",
        path: "fixed_plates",
        Component: FixedPlates,
        loader: requirePermission(PermissionEnum.REPORT_PASSAGE_CHANGED_PLATES)
    },
    {
        id: "image-export",
        path: "image_export",
        Component: ImageExport,
        loader: requirePermission(PermissionEnum.REPORT_PASSAGE_IMAGE_EXPORT)
    },
    {
        id: "interconnected-search-audit",
        path: "interconnected_search_audit",
        Component: InterconnectedSearchAudit,
        loader: requirePermission(PermissionEnum.REPORT_PASSAGE_SENTRY_CLOUD)
    },
    {
        id: "user-sessions",
        path: "user_sessions",
        Component: UserSessions,
        loader: requirePermission(PermissionEnum.REPORT_USER_SESSIONS)
    },
    {
        id: "vehicle-passages-search",
        path: "vehicle_passages_search",
        Component: VehiclePassagesSearch,
        loader: requirePermission(PermissionEnum.REPORT_PASSAGE_SEARCH)
    },
    {
        id: "system-usage",
        path: "system_usage",
        Component: SystemUsage,
        loader: requirePermission(PermissionEnum.REPORT_USER_SYSTEM_USAGE)
    },
    {
        id: "dispatch-arrival",
        path: "dispatch_arrival",
        Component: DispatchArrival,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_TIME_ARRIVAL)
    },
    {
        id: "attendance-sequence",
        path: "attendance_sequence",
        Component: AttendanceSequence,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_ATTENDANCE_SEQUENCE)
    },
    {
        id: "garrison-actions",
        path: "garrison_actions",
        Component: GarrisonActions,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_GARRISON_ACTIONS)
    },
    {
        id: "ocr-indicator",
        path: "ocr_indicator",
        Component: OcrIndicator,
        loader: requirePermission(PermissionEnum.REPORT_PCL_OCR)
    },
    {
        id: "sla-cameras",
        path: "sla_cameras",
        Component: SlaCameras,
        loader: requirePermission(PermissionEnum.REPORT_PCL_CAMERA_SLA)
    },
    {
        id: "sla-server",
        path: "sla_server",
        Component: SlaServer,
        loader: requirePermission(PermissionEnum.REPORT_SERVER_SLA)
    },
    {
        id: "approval-actions",
        path: "approval_actions",
        Component: ApprovalActions,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_BO_APPROVAL_ACTIONS)
    },
    {
        id: "cortex-occurrence-actions",
        path: "cortex_occurrence_actions",
        Component: CortexOccurrenceActions,
        loader: requirePermission(PermissionEnum.REPORT_CORTEX_OCCURRENCE_ACTIONS)
    },
    {
        id: "collection-point-priority",
        path: "collection_point_priority",
        Component: CollectionPointPriority,
        loader: requirePermission(PermissionEnum.REPORT_PCL_PRIORITY)
    },
    {
        id: "sla-collection-point",
        path: "sla_collection_point",
        Component: SlaCollectionPoint,
        loader: requirePermission(PermissionEnum.REPORT_PCL_SMARTCAPTURE_SLA)
    },
    {
        id: "attendance-quality",
        path: "attendance_quality",
        Component: AttendanceQuality,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_ATTENDANCE_QUALITY)
    },
    {
        id: "information-quality",
        path: "information_quality",
        Component: InformationQuality,
        loader: requirePermission(PermissionEnum.REPORT_OCCURRENCE_QUALITY)
    },
    {
        id: "dispatch-quality",
        path: "dispatch_quality",
        Component: DispatchQuality,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_DISPATCH_QUALITY)
    },
    {
        id: "audit",
        path: "audit",
        Component: Audit,
        loader: requirePermission(PermissionEnum.REPORT_AUDIT)
    },
    {
        id: "integration-events",
        path: "integration_events",
        Component: IntegrationEvents,
        loader: requirePermission(PermissionEnum.REPORT_EXTERNAL_ALARMS_ACTIONS)
    },
    {
        id: "nature-actions",
        path: "nature_actions",
        Component: NatureActions,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_NATURE_ACTIONS)
    },
    {
        id: "nature-deviation",
        path: "nature_deviation",
        Component: NatureDeviation,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_NATURE_DEVIATION)
    },
    {
        id: "km-check",
        path: "km_check",
        Component: KmCheck,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_GARRISON_KM_CHECK)
    },
    {
        id: "vehicle-control-mileage",
        path: "vehicle_controlmileage",
        Component: VehicleControlMileage,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_VEHICLE_KM_CONTROL)
    },
    {
        id: "vehicle-traffic",
        path: "vehicle_traffic",
        Component: VehicleTraffic,
        loader: requirePermission(PermissionEnum.PASSAGE_SEARCH_REPORT)
    },
    {
        id: "registered-occurrence-vehicles",
        path: "registered_occurrence_vehicles",
        Component: RegisteredOccurrenceVehicles,
        loader: requirePermission(PermissionEnum.REPORT_OCCURRENCE_VEHICLE)
    },
    {
        id: "equipments-in-use",
        path: "equipments_in_use",
        Component: EquipmentsInUse,
        loader: requirePermission(PermissionEnum.REPORT_MANAGEMENT_EQUIPMENTS_IN_USE)
    },
    {
        id: "fixed-post-inspection",
        path: "fixed-post-inspection",
        Component: FixedPostInspection,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_FIXED_POST_INSPECTION)
    },
    {
        id: "notification-info",
        path: "notification_info",
        Component: NotificationInfo,
        loader: requirePermission(PermissionEnum.REPORT_NOTIFICATION_INFO)
    },
    {
        id: "dispatch-sequence",
        path: "dispatch_sequence",
        Component: DispatchSequence,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_DISPATCH_SEQUENCE)
    },
    {
        id: "displacement-sequence",
        path: "displacement_sequence",
        Component: DisplacementList,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_DISPATCH_DISPLACEMENT_SEQUENCE)
    },
    {
        id: "garrison-inspection",
        path: "garrison_inspection",
        Component: GarrisonInspection,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_VEHICLE_INSPECTION)
    },
    {
        id: "dispatch-by-place",
        path: "dispatch_by_place",
        Component: DispatchByPlace,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_BY_PLACE)
    },
    {
        id: "fleet-maintenances",
        path: "fleet-maintenances",
        Component: FleetMaintenances,
        loader: requirePermission(PermissionEnum.REPORT_MANAGEMENT_FLEET_MAINTENANCES)
    },
    {
        id: "fleet-supplies",
        path: "fleet-supplies",
        Component: FleetSupplies,
        loader: requirePermission(PermissionEnum.REPORT_MANAGEMENT_FLEET_SUPPLIES)
    },
    {
        id: "traffic-flow-route",
        path: "traffic_flow_route",
        Component: TrafficFlowRoute,
        loader: requirePermission(PermissionEnum.REPORT_TRAFFIC_FLOW_ROUTE)
    },
    {
        id: "garrison-list",
        path: "garrison_list",
        Component: GarrisonList,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_GARRISON_LIST)
    },
    {
        id: "garrison-location-map",
        path: "garrison_location_map",
        Component: GarrisonLocationMap,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_GARRISON_LIST)
    },
    {
        id: "garrison-map",
        path: "garrison_map",
        Component: GarrisonMap,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_GARRISON_MAP)
    },
    {
        id: "traffic-flow-point",
        path: "traffic_flow_point",
        Component: TrafficFlowPoint,
        loader: requirePermission(PermissionEnum.REPORT_TRAFFIC_FLOW_POINT)
    },
    {
        id: "material-movements-info",
        path: "material_movements",
        Component: MaterialMovements,
        loader: requirePermission(PermissionEnum.REPORT_MANAGEMENT_MATERIAL_MOVEMENTS)
    },
    {
        id: "material-movements-print",
        path: "material_movements_info",
        Component: MaterialMovementsInfo,
        loader: requirePermission(PermissionEnum.REPORT_MANAGEMENT_MATERIAL_MOVEMENTS)
    },
    {
        id: "material-x-storage-info",
        path: "material-x-storage-info",
        Component: MaterialXStorageInfo,
        loader: requirePermission(PermissionEnum.ERP_MATERIALS_RESPONSIBLE)
    },
    {
        id: "occurrence-associated-vehicles",
        path: "occurrence_associated_vehicles",
        Component: OccurrenceAssociatedVehicles,
        loader: requirePermission(PermissionEnum.REPORT_OCCURRENCE_MONITORING)
    },
    {
        id: "effective-training",
        path: "effective_training",
        Component: EffectiveTraining,
        loader: requirePermission(PermissionEnum.REPORT_EFFECTIVE_TRAINING)
    },
    {
        id: "occurrence-reasons",
        path: "occurrence_reasons",
        Component: OccurrenceReasons,
        loader: requirePermission(PermissionEnum.REPORT_OCCURRENCE_REASON)
    },
    {
        id: "responsible-bo",
        path: "responsible_bo",
        Component: ResponsibleBo,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_RESPONSIBLE_BOGCM)
    },
    {
        id: "encounter-xray",
        path: "encounter_x_ray",
        Component: EncounterXray,
        loader: requirePermission(PermissionEnum.REPORT_ENCOUNTER_XRAY)
    },
    {
        id: "encounter-heat-map",
        path: "encounter_heat_map",
        Component: EncounterHeatMap,
        loader: requirePermission(PermissionEnum.REPORT_ENCOUNTER_HEAT_MAP)
    },
    {
        id: "agent-productivity",
        path: "agent_productivity",
        Component: AgentProductivity,
        loader: requirePermission(PermissionEnum.REPORT_AGENT_PRODUCTIVITY)
    },
    {
        id: "dispatch-xray",
        path: "dispatch_x_ray",
        Component: DispatchXray,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_DISPATCH_XRAY)
    },
    {
        id: "event-x-ray",
        path: "event_x_ray",
        Component: EventXRay,
        loader: requirePermission(PermissionEnum.REPORT_EVENT_XRAY)
    },
    {
        id: "clone-xray",
        path: "clone_x_ray",
        Component: CloneXray,
        loader: requirePermission(PermissionEnum.REPORT_NOTIFICATION_XRAY)
    },
    {
        id: "passage-labels-xray",
        path: "passage-labels-x-ray",
        Component: PassageLabelsXray,
        loader: requirePermission(PermissionEnum.REPORT_PASSAGE_LABEL_XRAY)
    },
    {
        id: "occurrence-mapping",
        path: "occurrence_mapping",
        Component: OccurrenceMapping,
        loader: requirePermission(PermissionEnum.REPORT_OCCURRENCE_MAP)
    },
    {
        id: "material-cautions-print",
        path: "material_cautions",
        Component: MaterialCautions,
        loader: requirePermission(PermissionEnum.REPORT_MANAGEMENT_MATERIAL_CAUTIONS)
    },
    {
        id: "agent-info",
        path: "effective_info/:id?",
        Component: AgentInfo,
        loader: requirePermission(PermissionEnum.ERP_PERSONAL)
    },
    {
        id: "occurrence-details",
        path: "occurrences_details",
        Component: OccurrencesDetails,
        loader: requirePermission(PermissionEnum.REPORT_OCCURRENCE_DETAILS)
    },
    {
        id: "alarm-timeline",
        path: "alarm_timeline",
        Component: AlarmTimeline,
        loader: requirePermission(PermissionEnum.ALARM_PRINT)
    },
    {
        id: "occurrence-history",
        path: "occurrence_history/:id?",
        Component: OccurrenceHistory,
        loader: requirePermission(PermissionEnum.OCCURRENCE_PRINT)
    },
    {
        id: "occurrence-print",
        path: "occurrence_print",
        Component: OccurrencePrint,
        loader: requirePermission(PermissionEnum.OCCURRENCE_PRINT)
    },
    {
        id: "export-zoomed-passage-images",
        path: "export_zoomed_passage_images",
        Component: ZoomedPassage,
        loader: requirePermission([PermissionEnum.PASSAGE_SEARCH, PermissionEnum.PASSAGE_EXPORT])
    },
    {
        id: "sos-xray",
        path: "sos_x_ray",
        Component: SosXray,
        loader: requirePermission(PermissionEnum.REPORT_SOS_XRAY)
    },
    {
        id: "solicitation-xray",
        path: "solicitation_x_ray",
        Component: SolicitationXray,
        loader: requirePermission(PermissionEnum.REPORT_SOLICITATION_XRAY)
    },
    {
        id: "geo-comparison",
        path: "geo_comparison",
        Component: GeoComparison,
        loader: requirePermission(PermissionEnum.REPORT_OCCURRENCE_GEOREF_COMPARISON)
    },
    {
        id: "dispatch-info",
        path: "dispatch_info",
        Component: DispatchInfo,
        loader: requirePermission(PermissionEnum.DISPATCH_DISPATCH)
    },
    {
        id: "garrison-info",
        path: "garrison_info/:id?",
        Component: GarrisonInfo,
        loader: requirePermission(PermissionEnum.GARRISON_WEB)
    },
    {
        id: "citizen-history-info",
        path: "citizen-history-info/:id?",
        Component: CitizenHistoryInfo,
        loader: requirePermission([PermissionEnum.SOS_MANAGE_CITIZEN, PermissionEnum.SOS_MANAGE_EVENTS, PermissionEnum.SOS_VIEW])
    },
    {
        id: "attendance-info",
        path: "attendance_info/:id?",
        Component: AttendanceInfo,
        loader: requirePermission([PermissionEnum.ATTENDANCE_WEB, PermissionEnum.ATTENDANCE_VISUALIZATION])
    },
    {
        id: "schedule-attendance-info",
        path: "schedule_attendance_info",
        Component: ScheduleAttendanceInfo,
        loader: requirePermission(PermissionEnum.ATTENDANCE_SCHEDULE)
    },
    {
        id: "contactid-events-info",
        path: "contactid_events_info",
        Component: ContactId,
        loader: requirePermission(PermissionEnum.CONTACTID)
    },
    {
        id: "alarm-actions",
        path: "alarm_actions",
        Component: AlarmActions,
        loader: requirePermission(PermissionEnum.REPORT_ALARMS_ACTIONS)
    },
    {
        id: "alarm-statistics",
        path: "alarm_statistics",
        Component: AlarmStatistics,
        loader: requirePermission(PermissionEnum.REPORT_ALARMS_STATISTICS)
    },
    {
        id: "bo-apprehensions",
        path: "bo_apprehensions",
        Component: BoApprehensions,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_BO_APPREHENSIONS)
    },
    {
        id: "bo-auditorship",
        path: "bo_auditorship",
        Component: BoAuditorship,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_BO_AUDITORSHIP)
    },
    {
        id: "bo-timeline",
        path: "bo_timeline",
        Component: BoTimeline,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_BO_TIMELINE)
    },
    {
        id: "solicitation-info",
        path: "solicitation-info",
        Component: SolicitationInfo,
        loader: requirePermission(PermissionEnum.ECAP)
    },
    {
        id: "corporation-actions",
        path: "corporation_actions",
        Component: CorporationActions,
        loader: requirePermission(PermissionEnum.REPORT_CORPORATION_ACTIONS)
    },
    {
        id: "document-expiration",
        path: "document_expiration",
        Component: DocumentExpiration,
        loader: requirePermission(PermissionEnum.REPORT_DOCUMENT_EXPIRATION)
    },
    {
        id: "traffic-vehicle-stay",
        path: "traffic_vehicle_stay",
        Component: TrafficVehicleStay,
        loader: requirePermission(PermissionEnum.REPORT_TRAFFIC_VEHICLE_STAY)
    },
    {
        id: "sos-management",
        path: "sos_management",
        Component: SosManagement,
        loader: requirePermission(PermissionEnum.REPORT_SOS_MANAGEMENT)
    },
    {
        id: "sos-history-info",
        path: "sos_history",
        Component: SosHistory,
        loader: requirePermission(PermissionEnum.REPORT_SOS_HISTORY)
    },
    {
        id: "generic_form_analyse",
        path: "generic_form_analyse",
        Component: GenericFormAnalyse,
        loader: requirePermission(PermissionEnum.REPORT_GENERIC_FORM_ANALYSE)
    },
    {
        id: "agent-absences",
        path: "agent_absences",
        Component: AgentAbsences,
        loader: requirePermission(PermissionEnum.REPORT_AGENT_ABSENCES)
    },
    {
        id: "bo-stolen-items",
        path: "bo_stolen_items",
        Component: BoStolenItems,
        loader: requirePermission(PermissionEnum.REPORT_DISPATCH_BO_STOLEN_ITEMS)
    },
    {
        id: "sentry-cloud-search-map",
        path: "sentry_cloud_search_map",
        Component: SentryCloudSearchMap,
        loader: requirePermission(PermissionEnum.PASSAGE_SEARCH_SENTRYCLOUD)
    },
];

export default RouterReports;